<div fxLayout="row" fxLayoutAlign="space-between center" class="w-100 h-44" fxFlex>
    @if (label) {
        <div class="t1-semi-bold w-100">{{ label | translate }}</div>
    }
    @if (form) {
        @if (chips?.length && !!form.controls.classificationBy) {
            <div fxLayout="row" fxLayoutAlign="start center">
                @if (chips.length) {
                    <mat-chip-listbox
                        [multiple]="false"
                        [selectable]="true"
                        [hideSingleSelectionIndicator]="true">
                        @for (chip of chips; track chip) {
                            <mat-chip-option class="t4"
                                             [selected]="form.get(chipsFormControlName).value === chip"
                                             (selectionChange)="onChipSelectionChange(chip)">
                                {{ 'i18n_af_filter_field_' + chipsFormControlName + '#' + chip | translate }}
                            </mat-chip-option>
                        }
                    </mat-chip-listbox>
                }
            </div>
        }
        <form [formGroup]="form" fxLayout="row" fxLayoutAlign="end center" class="w-100 h-100" fxFlex fxLayoutGap="16px">
            @if (form.controls.dateRange) {
                <af-date-range-picker-field [form]="form.controls.dateRange"
                                            startTime="00:00"
                                            endTime="23:59"
                                            [maxDate]="maxDate"
                                            [hasTime]="hasTime"
                                            [hasPickerActions]="hasPickerActions"
                                            [startDate]="currentPeriodStartDate"
                                            [endDate]="currentPeriodEndDate"
                                            (openPickerListener)="formChangesSubscription?.unsubscribe()"
                                            (closePickerListener)="subscribeToFormChanges()"/>
            }
            @if (form.controls.dateRangeComparison) {
                @if (form.controls.dateRangeComparison.controls.dateRangePreviousPeriod) {
                    <af-date-range-picker-field
                        [form]="form.controls.dateRangeComparison.controls.dateRangePreviousPeriod"
                        startTime="00:00"
                        endTime="23:59"
                        label="i18n_af_labelRangePrevious"
                        [startDate]="previousPeriodStartDate"
                        [endDate]="previousPeriodEndDate"
                        (openPickerListener)="formChangesSubscription?.unsubscribe()"
                        (closePickerListener)="subscribeToFormChanges()"/>
                }
                @if (form.controls.dateRangeComparison.controls.dateRangeCurrentPeriod) {
                    <af-date-range-picker-field
                        [form]="form.controls.dateRangeComparison.controls.dateRangeCurrentPeriod"
                        startTime="00:00"
                        endTime="23:59"
                        class="ml-16"
                        label="i18n_af_labelRangeCurrent"
                        [startDate]="currentPeriodStartDate"
                        [endDate]="currentPeriodEndDate"
                        (openPickerListener)="formChangesSubscription?.unsubscribe()"
                        (closePickerListener)="subscribeToFormChanges()"/>
                }
            }
            @if (showDate) {
                <div class="read-only-date">{{ currentDateTime }}</div>
            }
            @if (form.controls.organizationTypes) {
                <af-dictionary-selector [control]="form.controls.organizationTypes"
                                        [shouldAddSelectAll]="true"
                                        [selectAllLabel]="'i18n_af_labelAllOrganization#' + this.allOrganizationLabel"
                                        [isMultiple]="true"
                                        [hasSearch]="true"
                                        dictionaryName="binTypes"
                                        class="h-100"
                                        fxFlexAlign="center"
                                        selectedCountPlaceholder="i18n_af_placeholderOrganizationSelectedCount"
                                        placeholder="i18n_af_placeholderOrganizationType"/>
            }
            @if (form.controls.organizations) {
                <af-dictionary-selector dictionaryName="bin"
                                        selectedCountPlaceholder="i18n_af_placeholderOrganizationSelectedCount"
                                        class="h-100 min-max-w-400"
                                        fxFlexAlign="center"
                                        [isDependentDictionary]="true"
                                        [parentDictionaryFormControl]="form.controls.organizationTypes"
                                        [shouldAddSelectAll]="true"
                                        [shouldSortDictionary]="true"
                                        [parentDictionaryField]="'code1'"
                                        [filterDictionaryBy]="filterOrganization"
                                        [control]="form.controls.organizations"
                                        [selectAllLabel]="'i18n_af_labelAllOrganization#' + this.allOrganizationLabel"
                                        [isMultiple]="true"
                                        [isParentDictionaryMultiple]="true"/>
            }
            @if (form.controls.organization) {
                <af-dictionary-selector dictionaryName="bin"
                                        class="h-100 min-max-w-400"
                                        fxFlexAlign="center"
                                        [control]="form.controls.organization"
                                        [selectAllLabel]="'i18n_af_labelAllOrganization#' + this.allOrganizationLabel"
                                        [shouldSortDictionary]="true"
                                        [shouldAddSelectAll]="true"
                                        [filterDictionaryBy]="filterOrganization"/>
            }
        </form>
    }
</div>
